import { render, staticRenderFns } from "./ProjectBar.vue?vue&type=template&id=a7674b1c&scoped=true&"
import script from "./ProjectBar.vue?vue&type=script&lang=js&"
export * from "./ProjectBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7674b1c",
  null
  
)

export default component.exports